/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 
jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
 
 Shopify.Products = (function() {

   var config = { 
     howManyToShow: 3,
     howManyToStoreInMemory: 40, 
     wrapperId: 'recently-viewed-products', 
     templateId: 'recently-viewed-product-template',
     onComplete: null
   };
   
   var productHandleQueue = [];
   var wrapper = null;
   var template = null;
   var shown = 0;

   var cookie = {
     configuration: {
       expires: 90,
       path: '/',
       domain: window.location.hostname
     },
     write: function(name, recentlyViewed) {
       jQuery.cookie(name, recentlyViewed.join(' '), this.configuration);
     },
     read: function(name) {
       var recentlyViewed = [];
       var cookieValue = jQuery.cookie(name);
       if (cookieValue !== null) {
         recentlyViewed = cookieValue.split(' ');
       }
       return recentlyViewed;        
     },
     destroy: function() {
       jQuery.cookie(this.name, null, this.configuration);
     },
     remove: function(name, productHandle) {
       var recentlyViewed = this.read(name);
       var position = jQuery.inArray(productHandle, recentlyViewed);
       if (position !== -1) {
         recentlyViewed.splice(position, 1);
         this.write(name, recentlyViewed);
       }       
     }
   };
   
   var finalize = function() {
     wrapper.show();
      var historySwiper = new Swiper('.js-history-caroucel', {
        loop: false,
        slidesPerView: "auto",
        freeMode: true,
        navigation: {
          nextEl: '.swiper-history-button-next',
          prevEl: '.swiper-history-button-prev'
        }
      });
      var memorialHistorySwiper = new Swiper('.js-memorial-history-caroucel', {
        loop: false,
        slidesPerView: "auto",
        freeMode: true,
        navigation: {
          nextEl: '.swiper-memorial-history-button-next',
          prevEl: '.swiper-memorial-history-button-prev'
        }
      });


     // If we have a callback.
     if (!config.onComplete) {
       try {
         config.onComplete = true;
//          config.onComplete();
       } catch (error) { }
     }  
   };
   
   var moveAlong = function(name) {
     if (productHandleQueue.length && shown < config.howManyToShow) {
       // カタログは表示に含めない
       if(productHandleQueue[0].match("catalog_")) {
         productHandleQueue.shift();
         moveAlong(name);
         return false;
       }
       
       jQuery.ajax({
         dataType: 'json',
         url: '/products/' + productHandleQueue[0] + '.js',
         cache: false,
         success: function(product) {
           template.tmpl(product).appendTo(wrapper); 
           productHandleQueue.shift();
           shown++;
           moveAlong(name);
         },
         error: function() {
           cookie.remove(name, productHandleQueue[0]);
           productHandleQueue.shift();
           moveAlong(name);
         }
       });
     }
     else {
       finalize();
     }
     
   };
   
   return {
    
     resizeImage: function(src, size) {
       if (src == null) {
         // TODO: 画像表示させる
         return null;
       }
       
       if (size == null) {
         return src;
       }

       if (size == 'master') {
         return src.replace(/http(s)?:/, "");
       }

       var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);

       if (match != null) {
         var prefix = src.split(match[0]);
         var suffix = match[0];

         return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "")
       } else {
         return null;
       }
     },

     showRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_recently_viewed');
       
       // Template and element where to insert.
       template = jQuery('#' + config.templateId);
       wrapper = jQuery('#' + config.wrapperId);
       
       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && template.length && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong('shopify_recently_viewed');    
       }

     },
     
     showRecentlyMemorialViewed: function(params) {
       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_recently_memorial_viewed');
       
       // Template and element where to insert.
       template = jQuery('#recently-viewed-memorials-template');
       wrapper = jQuery('#recently-viewed-memorials');
       
       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && template.length && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong('shopify_recently_memorial_viewed');    
       }

     },
     
     showDocumentRequest: function(params) {
       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_document_request');
       
       // Template and element where to insert.
       template = jQuery('#document-request-template');
       wrapper = jQuery('#document-request');
       
       // How many products to show.
       config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

       // If we have any to show.
       if (config.howManyToShow && template.length && wrapper.length) {
         // Getting each product with an Ajax call and rendering it on the page.
         moveAlong('shopify_document_request');    
       }

     },
     
     getRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_recently_viewed');
       return productHandleQueue;       

     },

     getRecentlyMemorialViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_recently_memorial_viewed');
       return productHandleQueue;       

     },

     
     getDocumentRequest: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       productHandleQueue = cookie.read('shopify_document_request');

       return productHandleQueue;       

     },

     getConfig: function() {
       return config;
     },

     clearList: function() {
       cookie.destroy();      
     },
     
     recordRecentlyViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read('shopify_recently_viewed');

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
        var productHandle = decodeURIComponent(window.location.pathname.match(/\/products\/(.*)/)[1]);
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);              
         }

         // Update cookie.
         cookie.write('shopify_recently_viewed', recentlyViewed);

       }
       
     },
   
    recordRecentlyMemorialViewed: function(params) {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var recentlyViewed = cookie.read('shopify_recently_memorial_viewed');

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1) {

         // What is the product handle on this page.
        var productHandle = decodeURIComponent(window.location.pathname.match(/\/products\/(.*)/)[1]);
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, recentlyViewed);
         // If not in memory.
         if (position === -1) {
           // Add product at the start of the list.
           recentlyViewed.unshift(productHandle);
           // Only keep what we need.
           recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
         }
         else {
           // Remove the product and place it at start of list.
           recentlyViewed.splice(position, 1);
           recentlyViewed.unshift(productHandle);              
         }

         // Update cookie.
         cookie.write('shopify_recently_memorial_viewed', recentlyViewed);

       }
       
     },
     
     recordDocumentRequest: function(params, handle = '') {

       var params = params || {};

       // Update defaults.
       jQuery.extend(config, params);

       // Read cookie.
       var requests = cookie.read('shopify_document_request');
       requests = $.unique(requests);

       // If we are on a product page.
       if (window.location.pathname.indexOf('/products/') !== -1 || handle) {

         if(handle) {
           var productHandle = handle;
         } else {
           // What is the product handle on this page.
          var productHandle = decodeURIComponent(window.location.pathname.match(/\/products\/(.*)/)[1]);
         }
         // In what position is that product in memory.
         var position = jQuery.inArray(productHandle, requests);
         // If not in memory.
         if (position === -1) {
           if(productHandle.match("catalog_")) {
             requests.push(productHandle);
           } else {
             // Add product at the start of the list.
             requests.unshift(productHandle);
             // Only keep what we need.
             requests = requests.splice(0, config.howManyToStoreInMemory);
           }
         }
         else {
           // Remove the product and place it at start of list.
           requests.splice(position, 1);
           if(productHandle.match("catalog_")) {
             requests.push(productHandle);              
           } else {
             requests.unshift(productHandle);              
           }
         }

         // Update cookie.
         cookie.write('shopify_document_request', requests);

       }
       
     },
     
     removeDocumentRequest: function(params, handle = '') {

       if(handle == '') {
         var handle = decodeURIComponent(window.location.pathname.match(/\/products\/(.*)/)[1]);
       }

       cookie.remove('shopify_document_request', handle);

     }

   };

 })();